import { Link } from "react-router";
import { RiArrowLeftLongLine } from "react-icons/ri";
import { all_routes } from "../../feature-module/router/all_routes";
import BackButton from "./BackButton";
import { Button } from "antd";

interface BreadCrumbProps {
  title: string;
  prevTitle?: string;
  prevLink?: string;
  linkTitle?: string;
  showGuideBtns?: string | null;
  backLink?: string | null;
}

// ------------
interface BreadcrumbItem {
  label?: string;
  path?: string;
  icon?: string;
  active?: boolean;
}
interface PageBreadcrumbProps {
  title: string;
  breadcrumbs: BreadcrumbItem[];

  showBackButton?: boolean;
  backRoute?: string;

  showDownloadButton?: boolean;
  handleDownload?:()=>void;

  showGuideButton?: boolean;
  onGuideClick?: () => void;
}
// ------------

const BreadCrumbForm = ({
  title = "",
  prevTitle = "",
  prevLink = "",
  // hasBackButton = false,
  backLink = null,
  showGuideBtns = null,
}: BreadCrumbProps) => {
  return (
    <>
      <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
        <div className="my-auto mb-2">
          <h2 className="mb-1">{title}</h2>
          <nav>
            <ol
              className="breadcrumb mb-0 d-flex align-items-center gap-1"
              style={{ fontSize: "14px" }}
            >
              <li className="breadcrumb-item ">
                <Link
                  to={all_routes.dashboard}
                  className="text-decoration-none text-secondar breadcrumb-item"
                >
                  <i className="ti ti-smart-home pb-0" /> /
                </Link>
              </li>
              {/* {prevTitle && <li className="breadcrumb-item">{prevTitle}</li>} */}
              {prevTitle && (
                <li>
                  <Link
                    to={prevLink}
                    className="text-decoration-none text-secondar breadcrumb-item"
                  >
                    {prevTitle} /
                  </Link>
                </li>
              )}
              <li className="breadcrumb-item active" aria-current="page">
                {title}
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center justify-content-end flex-wrap ">
          {backLink && <BackButton route={backLink} />}
        </div>
      </div>
    </>
  );
};
export default BreadCrumbForm;

// ========= PageBreadcrumb =========
export const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({
  title,
  breadcrumbs = [],
  showBackButton = false,
  backRoute = "",
  showGuideButton = false,
  onGuideClick,
  showDownloadButton = false,
  handleDownload = () => {}
}) => {
  return (
    <div className="d-md-flex d-block align-items-end justify-content-between page-breadcrumb my-2 ">
      <div className="my-auto ">
        <h2 className="mb-1">{title}</h2>

        <nav>
          <ol
            className="breadcrumb mb-0 d-flex align-items-center gap-0"
            style={{ fontSize: "14px" }}
          >
            <li className="breadcrumb-item ">
              <Link
                to={all_routes.dashboard}
                className="text-decoration-none text-secondar breadcrumb-item"
              >
                <i className="ti ti-smart-home pb-0" />
              </Link>
            </li>
            {breadcrumbs.map((item, index) => (
              <li
                key={index}
                className={`breadcrumb-item ${item.active ? "active" : ""}`}
                aria-current={item.active ? "page" : undefined}
              >
                {item.active ? (
                  item.label
                ) : (
                  <Link
                    to={item.path || "#"}
                    className="text-decoration-none text-secondary"
                  >
                    {item.icon ? <i className={item.icon} /> : item.label}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>

      {(showBackButton || showGuideButton || showDownloadButton) && (
        <div className="d-flex my-xl-auto right-content align-items-end justify-content-end flex-wrap mt-3 mt-md-0">
          <div className="text-end d-flex justify-content-end gap-1 gap-sm-2">
            {showBackButton && <BackButton route={backRoute} />}

            {showGuideButton && (
              <Button className="border-secondary" onClick={onGuideClick}>
                <i className="ti ti-info-circle-filled fs-16"></i>
                <div>Guide</div>
              </Button>
            )}

            {/* {showDownloadButton && (
              <button className="btn btn-sm btn-primary" onClick={handleDownload}>
                <i className="bi bi-download pe-2"></i>
                Download Excel
              </button>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};
